var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box variant-add-ons" }, [
    _vm.canEdit && _vm.step !== 0
      ? _c(
          "a",
          {
            staticClass: "edit",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.tc("booking.edit")) + "\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "section-label capitalize" }, [
      _vm._v("\n      " + _vm._s(_vm.titleLabel) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overview-items-wrapper" },
      [
        _c("see-details", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var opened = ref.opened
                return _vm._l(_vm.addOns, function (addOn) {
                  return _c(
                    "div",
                    {
                      key: addOn.sitecoreId,
                      staticClass: "add-on-item",
                      class: { "mb-3": opened },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "overview-item",
                          class: { "mb-2": opened, "mb-3": !opened },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "item label bold-item add-on__name",
                            },
                            [_vm._v(_vm._s(addOn.addOnName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "item-value bold-item add-on__total",
                            },
                            [_vm._v(_vm._s(_vm.getAddOnsTotal(addOn)))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "transition",
                        { attrs: { name: "expand-y" } },
                        [
                          opened
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "overview-items-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overview-item add-on__price-type",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "section-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getPriceAndTypeLabel(addOn)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overview-item small-margin",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.quantityLabel) +
                                              ": " +
                                              _vm._s(
                                                _vm.getTotalQuantity(addOn)
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    addOn.adultQuantity
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "overview-item small-margin",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "section-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.adultsLabel) +
                                                    ": " +
                                                    _vm._s(addOn.adultQuantity)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    addOn.childQuantity
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "overview-item small-margin",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "section-label add-on__child-quantity",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.childrenLabel) +
                                                    ": " +
                                                    _vm._s(
                                                      addOn.childQuantity
                                                    ) +
                                                    "\n                      "
                                                ),
                                                addOn.excludeKidsFromPriceCalculations &&
                                                _vm.tooltipMessage !== ""
                                                  ? _c(
                                                      "v-dropdown",
                                                      {
                                                        staticClass:
                                                          "tooltip tooltip-variant--add-on-footer",
                                                        attrs: {
                                                          distance: 25,
                                                          skidding: 0,
                                                          placement: "top",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "popper",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "tooltip-variant--add-on-footer tooltip-content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "tooltip-header",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "button",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "close-popper",
                                                                                    rawName:
                                                                                      "v-close-popper",
                                                                                  },
                                                                                ],
                                                                              staticClass:
                                                                                "icon-close",
                                                                              attrs:
                                                                                {
                                                                                  "aria-label":
                                                                                    _vm.tc(
                                                                                      "booking.close"
                                                                                    ),
                                                                                  tabindex:
                                                                                    "0",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "tooltip-body",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                _vm.tooltipMessage
                                                                              ) +
                                                                              "\n                          "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("button", {
                                                          staticClass:
                                                            "tooltip-icon icon-info",
                                                          attrs: {
                                                            "aria-label":
                                                              _vm.tooltipMessage,
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    addOn.data.selectedAddOnDates &&
                                    addOn.data.selectedAddOnDates.length > 0
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "overview-item small-margin",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.datesLabel)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            addOn.data.selectedAddOnDates,
                                            function (date) {
                                              return _c(
                                                "div",
                                                {
                                                  key: date,
                                                  staticClass:
                                                    "overview-item small-margin",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "section-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dateFormatted(
                                                            date
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }